import React from "react";
import style from "./styles/cursor-weapper.module.scss";

type CursorWrapperProps = {
  isActive: boolean;
  children: React.ReactNode;
};

const CursorWrapper = ({ isActive, children }: CursorWrapperProps) => {
  return <div className={isActive ? "" : style.inactive}>{children}</div>;
};

export default CursorWrapper;
